import { selectFactory } from '../../helpers';

import * as Constants from '../constants';

import { collectValueFields, selectFields, selectFromCollect } from './helpers';

export const selectStages = selectFields(Constants.FIELDS.STAGES);

export const selectStage = selectFactory({ selector: selectStages });

export const selectStageFields = selectFactory({ selector: selectStages });

export const selectStagesErrors = collectValueFields({
  field: Constants.STAGES_VALUE_FIELDS.ERROR,
  selector: selectStages,
});

export const selectStageError = selectFromCollect({ selector: selectStagesErrors });

export const selectStagesLoadings = collectValueFields({
  field: Constants.STAGES_VALUE_FIELDS.LOADING,
  selector: selectStages,
});

export const selectStageLoading = selectFromCollect({ selector: selectStagesLoadings });
